export default __webpack_public_path__ + "static/media/purple-smoke.c03b9de6.svg";